export enum FilterDefaultersStatusEnum {
  ALL = "ALL",
  PENDING = "PENDING",
  CANCELED = "CANCELED",
  EXPIRED = "EXPIRED",
  EXPIRED_SUBSCRIPTION = "EXPIRED_SUBSCRIPTION",
  NOT_STARTED_SUBSCRIPTION = "NOT_STARTED_SUBSCRIPTION",
  STARTED_SUBSCRIPTION = "STARTED_SUBSCRIPTION",
}
